import { getFeatureFlagValue } from '@experiences/feature-flags';
import {
    consumptionEntitlementToFeatureFlagNameMap,
    predefinedConsumptionEntitlements,
} from '@experiences/util';

export function getAvailableConsumableEntitlements(): string[] {
    return predefinedConsumptionEntitlements.filter(
        entitlement => getFeatureFlagValue(consumptionEntitlementToFeatureFlagNameMap[entitlement]),
    );
}
